import React, { useEffect, useState } from 'react'
import { Helmet } from 'react-helmet'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

const defaultState = {
  titleName: ''
}
const TitlePrint = ({ page, profile }) => {
  useEffect(() => {
    getTitle(page)
  }, [])

  const [ownState, setOwnState] = useState(defaultState)

  const getTitle = (page) => {
    const titlesSite = (process.env.REACT_APP_TITLES && JSON.parse(process.env.REACT_APP_TITLES)) || titleDefault()
    if (Object.keys(titlesSite).find(key => parseInt(key) === ((profile && parseInt(profile['custom:catalog_id'])) || parseInt(process.env.REACT_APP_CATALOG_ID)))) {
      setOwnState({ titleName: (page ? (page + ' - ') : '') + titlesSite[((profile && parseInt(profile['custom:catalog_id'])) || parseInt(process.env.REACT_APP_CATALOG_ID))].titleName })
    }
  }
  const titleDefault = () => {
    return {
      [((profile && parseInt(profile['custom:catalog_id'])) || parseInt(process.env.REACT_APP_CATALOG_ID))]: {
        'titleName': process.env.REACT_APP_TITLE || 'Catálogo de Prêmios | WebPrêmios'
      }
    }
  }
  return (
    <Helmet>
      <title>{`${ownState.titleName || ''}`}</title>
    </Helmet>
  )
}

TitlePrint.propTypes = {
  page: PropTypes.string,
  profile: PropTypes.object
}

const mapStateToProps = state => {
  const {
    oidc: { user }
  } = state
  const { profile } = user || {}

  return { profile }
}

export default connect(mapStateToProps)(TitlePrint)



// WEBPACK FOOTER //
// ./src/App/Shell/TitlePrint.js